import Navbar from "../../components/Navbar";

const AdminProfile = () => {
  const role = localStorage.getItem("role");
  return (
    <div>
      <Navbar role={role} />
      <div style={{ textAlign: "center", marginTop: "80px" }}>
        <h1>Admin Profile</h1>
        <p>Here you can view and edit your personal details.</p>
      </div>
    </div>
  );
};

export default AdminProfile;
